import { Component } from '@angular/core';
import { IdeateChallengeComponent } from '../ideate-challenge.component';

@Component({
  selector: 'app-ideate-challenge-top-ideas',
  templateUrl: './ideate-challenge-top-ideas.component.html',
  styleUrls: ['./ideate-challenge-top-ideas.component.scss']
})
export class IdeateChallengeTopIdeasComponent {

    constructor(public ideateChallengeComponent: IdeateChallengeComponent) { }
  
}
